import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet } from '../kho-de-nghi-nhap-kho-page-model/kho-de-nghi-nhap-kho-page.model';

const API_ROOT_URL = environment.ApiRoot + '/kho';
const API_ROOT_URL_IMPORT_DENGHI_FILE = environment.ApiRoot + '/importdenghifile';

@Injectable()
export class DeNghiNhapKhoService {
	
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	lastData$: BehaviorSubject<DeNghiNhapKho[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DNNK_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/DNNK_Get_Detail', item, { headers: httpHeaders });
	}
	getItemById(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DNNK_Get_Item?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getLSNhapKho(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DNNK_Get_HistoryNK?Idct=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getId(Idct): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DNNK_Get_IDMaster?Idct=${Idct}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	// .. API download template
	downloadTemplateImport(): Observable<Blob>{
		const COD_COMPONENT = "COD_DNNK";
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set('CODComponent', COD_COMPONENT);
		return this.http.get<Blob>(API_ROOT_URL_IMPORT_DENGHI_FILE + '/DownloadFileTemplate', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	}
	/*---------------------------------------------------------------------- */


	/*-------------------------------POST Method---------------------------- */
	add(item: DeNghiNhapKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/DNNK_Insert', item, { headers: httpHeaders });
	}
	updatWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/DNNK_Update_With_Detail', item, { headers: httpHeaders });
	}
	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DNNK_Delete?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	checkCancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuDNNhapKho_Check_Cancel?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DNNK_Cancel?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/DNNK_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DNNKTemplateImport`;
	}
	// .. API import file
	startImportFile(data): Observable<any> {
		const COD_COMPONENT = "COD_DNNK";
		const url = API_ROOT_URL_IMPORT_DENGHI_FILE + '/handle_file_import_dnnk';
		const httpParams = new HttpParams().set('CODComponent', COD_COMPONENT);
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders, params: httpParams });
	}
  createForPurchaseOrder(item: DeNghiNhapKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/warehouse-request', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

	
	/*------------------------------ Qui trình ----------------------------- */
	duyet(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/DNNK_Update_StateConfirm', item, { headers: httpHeaders });
	}
	duyetTungHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/DNNK_DuyetHang', item, { headers: httpHeaders });
	}
	duyetNhieuHang(items): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/DNNK_DuyetNhieuHang', items, { headers: httpHeaders });
	}
	dongDeNghi(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet[]>(API_ROOT_URL+'/DNNK_DongDeNghi', item, { headers: httpHeaders });
	}
	dongDeNghiNhapDu(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+'/DNNK_DongDeNghiNhapDu', { headers: httpHeaders });
	}
	downloadExcel(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/DNNK_ExportExcel', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	  }
	/*---------------------------------------------------------------------- */
  getReferences(warehouseRequestId: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<any>(`${API_ROOT_URL}/detail/${warehouseRequestId}/references`, {
      headers: httpHeaders
    });
  }
}
